import React from 'react';
import Routes from './components/routes';


export default () => <Routes />;


// WEBPACK FOOTER //
// ./src/App.js